module.exports = __webpack_public_path__ + "media/images/paper_poster-af8d96173515291c98957f0021db90c1.png";